// TransectsForm.jsx
import UniversalEditableTable from '../UniversalComponents/UniversalEditableTable'//'@fileops/swmm-react'
import { Grid, Box } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Time Series Form is a group of data inputs usually shown when clicking on Timeseries in the main menu. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {string} targetType The name of the layer targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} saveEdits function that is called to save edits to the full model.
 * @returns UI for interactive swmm modeling.
 */
export default function TransectsForm({model, target, targetType, saveEdits }) {
  function updateTableData (data){
    if(model && model.TRANSECTS){
      saveEdits(data)
    }
  }
  
  return(
    <>
    {
      <>
      <Grid container>
        <Grid item xs={12}>
        {
          targetType && 
          targetType in model && 
          target &&
          target in model[targetType] &&
          <Grid container spacing={0} padding={0}>
            <Box sx={{width: '100%' }}>
              {<UniversalEditableTable colNames={['Station', 'Elev']} theData={(model && model.TRANSECTS)?model.TRANSECTS[target].GR:[]} updateData={updateTableData} />}
            </Box>
          </Grid>
        }
        </Grid>
      </Grid>
      </>
        }
    </>
  )
}